import storageManager from '@/api/storageManager';
import { getPersonsForCustomer, getPersonsGuestPreview } from './person';

export const loadPersons = async (payload) => {
	if (storageManager.auth.getToken()) {
		try {
			return await getPersonsForCustomer(payload);
		} catch (error) {
			const status = error?.response?.status;
			if (status === 401 || status === 403) {
				storageManager.auth.clearAuth();
				return getPersonsGuestPreview(payload);
			}

			throw error;
		}
	}

	return getPersonsGuestPreview(payload);
};
